/** GDPR regulation labels for PII entity types (matches text-classification/regulation-map.mjs). */

const ART_9 = new Set([
  'HEALTH_DATA',
  'GENETIC_DATA',
  'BIOMETRIC_DATA',
  'RELIGION_OR_BELIEF',
  'POLITICAL_OPINION',
  'SEXUAL_ORIENTATION',
  'TRADE_UNION_MEMBERSHIP',
  'ETHNIC_ORIGIN',
  'CRIMINAL_OFFENCE_DATA',
]);

const RECITAL_30 = new Set([
  'IP_ADDRESS',
  'DEVICE_IDENTIFIER',
  'COOKIE_IDENTIFIER',
  'ACCOUNT_IDENTIFIER',
  'AUTH_SECRET',
]);

export function regulationForEntityType(type) {
  if (ART_9.has(type)) {
    return 'Art. 9(1)';
  }
  if (type === 'PERSON_ROLE_OR_TITLE') {
    return 'Art. 88';
  }
  if (RECITAL_30.has(type)) {
    return 'Recital 30';
  }
  return 'Art. 4(1)';
}
